import script from "./AdmTurmasDetalhesView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdmTurmasDetalhesView.vue?vue&type=script&setup=true&lang=js"

import "./AdmTurmasDetalhesView.vue?vue&type=style&index=0&id=97ef99d0&lang=css"

const __exports__ = script;

export default __exports__